import { call, put, select } from 'typed-redux-saga';

import { cloudApi } from '../../../shared/helpers/transport';
import { ARTIFACT, CloudAPI } from '../../../shared/helpers/transport/cloud-api/types';
import { ARTIFACTS_FILTER_OPTION } from '../constants';
import { setFetchingStatus } from '../features/fetching/slice';
import { setItems } from '../features/history-items/slice';
import { selectFilterArtifacts, selectFilterFromTo } from '../selectors';
import { FETCHING_STATUS } from '../types';

export function* fullListReloadSaga() {
    yield* put(setItems({ items: [] }));
    yield* put(setFetchingStatus(FETCHING_STATUS.IN_PROGRESS));
    const artifacts = yield* select(selectFilterArtifacts);
    const fromTo = yield* select(selectFilterFromTo);
    const payload: CloudAPI.ConferencesHistory.Request = {};
    if (fromTo.from) {
        payload.from = new Date(`${fromTo.from}T00:00:00`).toISOString();
    }
    if (fromTo.to) {
        const toDate = new Date(`${fromTo.to}T00:00:00`);
        toDate.setDate(toDate.getDate() + 1);
        payload.to = toDate.toISOString();
    }
    if (artifacts !== ARTIFACTS_FILTER_OPTION.ALL_CONFS) {
        payload.artifact = {
            [ARTIFACTS_FILTER_OPTION.NO_ARTIFACTS]: ARTIFACT.WITHOUT_ARTIFACTS,
            [ARTIFACTS_FILTER_OPTION.WITH_RECORDING]: ARTIFACT.RECORDING,
            [ARTIFACTS_FILTER_OPTION.WITH_REPORT]: ARTIFACT.MEETING_REPORT,
            [ARTIFACTS_FILTER_OPTION.WITH_SUMMARY]: ARTIFACT.SUMMARIZATION,
        }[artifacts];
    }
    try {
        const response = yield* call([cloudApi, cloudApi.getConferencesHistoryBatch], payload);
        yield* put(
            setItems({
                iterationKey: response.iteration_key,
                items: response.items.map((item) => ({
                    shortUrlId: item.short_url_id,
                    meetingName: item.meeting_name,
                    startedAt: item.started_at,
                    endedAt: item.ended_at,
                    summarizationStatus: item.summarization_status,
                    cloudRecordingStatus: item.cloud_recording_status,
                    hasMeetingReport: item.has_meeting_report,
                    hasLocalRecording: item.has_local_recording,
                    sessionId: item.session_id,
                })),
            })
        );
    } catch (error) {
        yield* put(setFetchingStatus(FETCHING_STATUS.ERROR));
        return;
    }
    yield* put(setFetchingStatus(null));
}
